import { get, post } from '../utils/axios'

import { http } from 'wnl-xdsdk'
const axios = new http();

const checkVersion = () =>
    get("/user/checkVersion", {
        av: "1.0.0",
        client: "android",
        channel: 10000
    });

const getWxParamse = (data) => get("/h5/WeChat/WxTicket", data)

// http://192.168.2.85:9090/user/matchCode?userid=b2c3e68320774bb6bd3336cf07e216ac
const getCode = (data) => axios.get("/user/matchCode", data)

export {
    checkVersion,
    getWxParamse,
	getCode
};
